export default __webpack_public_path__ + "static/media/slide02.885662e1.jpg";